import { MenuItem } from "../../Type/Layout/Sidebar";

export const MenuList: MenuItem[] = [
  {
    title: "",
    Items: [
     
      {
        icon: "Home",
        id: 1,
        active: false,
        title: "Dashboard",
        path: `${import.meta.env.BASE_URL}/dashboard`,
        type: "link",
        
      },
      // {
      //   icon: "Star",
      //   id: 1,
      //   active: false,
      //   title: "Activation",
      //   children: [
      //     { path: `${import.meta.env.BASE_URL}/activation`, title: "Activation", type: "link" },
      //     // { path: `${import.meta.env.BASE_URL}/topupblukactivation`, title: "Bulk Activation", type: "link" },
      //     { path: `${import.meta.env.BASE_URL}/activationReport`, title: "Activation Report", type: "link" },
         
      //   ],
      // },
      // {
      //   icon: "Profile",
      //   id: 1,
      //   active: false,
      //   title: "Profile",
      //   children: [
      //     { path: `${import.meta.env.BASE_URL}/myprofile`, title: "My Profile", type: "link" },
      //     // { path: `${import.meta.env.BASE_URL}/Welcomeletter`, title: "Welcome Letter", type: "link" },
      //     // { path: `${import.meta.env.BASE_URL}/myidcard`, title: "My ID-Card", type: "link" },
      //   ],
      // },
      {
        icon: "Setting",
        id: 1,
        active: false,
        title: "Settings",
        children: [
          { path: `${import.meta.env.BASE_URL}/accountsettings`, title: "Bank Settings", type: "link" },
          { path: `${import.meta.env.BASE_URL}/welcomeletter`, title: "Welcome Letter", type: "link" },
          { path: `${import.meta.env.BASE_URL}/myprofile?tab=3`, title: "Update Password", type: "link" },
          // { path: `${import.meta.env.BASE_URL}/pinOrderReport`, title: "Pin Order Report", type: "link" },
        ],
      },
      // {
      //   icon: "Shield",
      //   id: 1,
      //   title: "Activate Bot",
      //   path: `${import.meta.env.BASE_URL}/activatebot`,
      //   type: "link",
      // },
      // {
      //   icon: "Star",
      //   id: 1,
      //   active: false,
      //   title: "Reward",
      //   children: [
      //     { path: `${import.meta.env.BASE_URL}/bonanza`, title: "Bonanza", type: "link" },
      //     { path: `${import.meta.env.BASE_URL}/LifeTimeReward`, title: "Lifetime Reward", type: "link" },
         
      //   ],
        
      // },
      // {
      //   icon: "Paper",
      //   id: 1,
      //   active: false,
      //   title: "Deposit Fund",
      //   children: [
      //     { path: `${import.meta.env.BASE_URL}/fxstdeposit`, title: "FXST Deposit", type: "link" },
      //     { path: `${import.meta.env.BASE_URL}/FxstTokenHistory`, title: "Token History", type: "link" },
      //     { path: `${import.meta.env.BASE_URL}/trc20`, title: "USDT(TRC20)", type: "link" },
      //     { path: `${import.meta.env.BASE_URL}/bep20`, title: "USDT(BEP20)", type: "link" },
      //     { path: `${import.meta.env.BASE_URL}/DepositHistory`, title: "Deposit History", type: "link" },
      //     { path: `${import.meta.env.BASE_URL}/requestfund?currency=INR`, title: "Request Fund INR", type: "link" },
      //     { path: `${import.meta.env.BASE_URL}/requestfund?currency=AED`, title: "Request Fund AED", type: "link" },  
      //     { path: `${import.meta.env.BASE_URL}/inrfundreport`, title: "Fund Report", type: "link" },       
          
      //   ],
        
      // },
      // {
      //   icon: "Wallet",
      //   id: 1,
      //   active: false,
      //   title: "Wallet Transfer",
      //   children: [
        
      //     { path: `${import.meta.env.BASE_URL}/FxstockWallet`, title: "Fxstock Wallet", type: "link" },
      //     // { path: `${import.meta.env.BASE_URL}/DepositWallet`, title: "Deposit Wallet", type: "link" },
      //     { path: `${import.meta.env.BASE_URL}/FxstPayWallet`, title: "FXST Pay Wallet", type: "link" },
      //     { path: `${import.meta.env.BASE_URL}/fxstockwalletreport`, title: "Wallet Report", type: "link" },
      //     { path: `${import.meta.env.BASE_URL}/p2ptransfer`, title: "P2P Transfer", type: "link" },
      //     { path: `${import.meta.env.BASE_URL}/p2pwalletreport`, title: "P2P Report", type: "link" },
      //   ],
      // },
      {
        icon: "Filter",
        id: 1,
        active: false,
        title: "E-Pin",
        children: [
          { path: `${import.meta.env.BASE_URL}/searchpin`, title: "Search Pin", type: "link" },
          { path: `${import.meta.env.BASE_URL}/SendMultiplePin`, title: "Send Multiple Pin", type: "link" },
          { path: `${import.meta.env.BASE_URL}/transferepin`, title: "Transfer E-Pin", type: "link" },
          { path: `${import.meta.env.BASE_URL}/pinOrderReport`, title: "Pin Order Report", type: "link" },
          
          
        ],
      },
      {
        icon: "Profile",
        id: 1,
        active: false,
        title: "Team Overview",
        children: [
          // { path: `${import.meta.env.BASE_URL}/blankpage`, title: "Blank Page", type: "link" },
          { path: `${import.meta.env.BASE_URL}/sponsorlist`, title: "My Direct", type: "link" },
          { path: `${import.meta.env.BASE_URL}/teamdownline`, title: "Team Downline", type: "link" },
          { path: `${import.meta.env.BASE_URL}/levelwiseteamlist`, title: "Levelwise Report", type: "link" },
          { path: `${import.meta.env.BASE_URL}/tree`, title: "Generation tree", type: "link" },
          // { path: `${import.meta.env.BASE_URL}/businessreport`, title: "Business Report", type: "link" },         
        ],
      },
      {
        icon: "Activity",
        id: 1,
        active: false,
        title: "My Income",
        children: [
          { path: `${import.meta.env.BASE_URL}/LevelIncome`, title: "Level Income", type: "link" },
          { path:`${import.meta.env.BASE_URL}/RewardStatus`,title:"Reward Income",type:"link" },
          // { path:`${import.meta.env.BASE_URL}/RewardIncome`,title:"Reward Income",type:"link" },
          { path:`${import.meta.env.BASE_URL}/TotalEarning`,title:"Total Earning",type:"link" }
        ],
      },
      
      
      {
          icon: "Work",
        id: 1,
        title: "Business Plan",
        // path: `http://122.160.25.202/fxstox/MemberPanel/BPlan.pdf`,
        type: "link",
        rel:"noopener noreferrer"
      },
      {
        icon: "Filter",
        id: 1,
        active: false,
        title: "Withdraw",
        children: [
         { path: `${import.meta.env.BASE_URL}/RequestWithdraw`, title: "Request Withdraw", type: "link" },
          // { path: `${import.meta.env.BASE_URL}/WithdrawHistory`, title: "Withdraw Report", type: "link" },
          { path: `${import.meta.env.BASE_URL}/WithdrawReportPage`, title: "Withdraw Report", type: "link" },
         
        ],
      },
      {
        icon: "Activity",
        id: 1,
        title: "News & Events",
        path: `${import.meta.env.BASE_URL}/newsandevents`,
        type: "link",
      },
      {
        icon: "Ticket",
        id: 1,
        title: "Support Ticket",
        path: `${import.meta.env.BASE_URL}/supportticket`,
        type: "link",
      },
      {
        icon: "Logout",
        id: 1,
        title: "Logout",
        path: `#`,
        type: "link",
      },
    ],
  },
];
